import { useCallback, useEffect, useState } from 'react'

export type PicklistSize = 'letter' | 'label4x6'

const STORAGE_KEY = 'picklist.defaultSize'
const EVENT = 'picklist-size-change'

export function getPicklistSize(): PicklistSize {
  const raw = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null
  return raw === 'label4x6' ? 'label4x6' : 'letter'
}

export function setPicklistSize(size: PicklistSize): void {
  window.localStorage.setItem(STORAGE_KEY, size)
  window.dispatchEvent(new CustomEvent(EVENT))
}

/** Reactive accessor for the default picklist size, synced across components and tabs. */
export function usePicklistSize(): [PicklistSize, (size: PicklistSize) => void] {
  const [size, setSize] = useState<PicklistSize>(getPicklistSize)

  useEffect(() => {
    const sync = () => setSize(getPicklistSize())
    window.addEventListener(EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  const update = useCallback((next: PicklistSize) => setPicklistSize(next), [])
  return [size, update]
}
